var path = 'ui-formly/types/action/index.html';
var html = "<span class=\"btn\" ng-class=\"btnStyle\" ng-click=\"onClick(model)\"><span ng-bind-html=\"to.btnHtml\"></span></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;